import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "home",
  "use": "home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"home\">\r\n\t<path d=\"M535.04 87.68l407.04 371.2-45.44 45.44L832 445.696v417.664l-32 32h-192l-32-32v-224H448v224l-32 32h-192l-32-32V446.208L128 504.32l-45.44-45.44 406.4-371.2h46.08zM256 388.032v443.328h128v-224l32-32h192l32 32v224h128V387.648L512 155.52 256 388.032z\" fill=\"currentColor\">\r\n\t</path>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol